export enum RateShopAction {
  SPOT_QUOTE = 'SPOT_QUOTE',
  SEND_TO_BROKERAGE = 'SEND_TO_BROKERAGE',
  WATERFALL_TENDER = 'WATERFALL_TENDER',
  RERATE = 'RERATE',
  REQUEST_SPOT_MARKET_BID = 'REQUEST_SPOT_MARKET_BID',
  CARGO_INSURANCE_PURCHASE = 'CARGO_INSURANCE_PURCHASE',
  CARGO_INSURANCE_CANCEL = 'CARGO_INSURANCE_CANCEL',
  REMOVE_FROM_DAT = 'REMOVE_FROM_DAT',
  REMOVE_FROM_TRUCKSTOP = 'REMOVE_FROM_TRUCKSTOP',
  POST_TO_LOADBOARD = 'POST_TO_LOADBOARD',
  CANCEL_ALL_SPOT_MARKET_BIDS = 'CANCEL_ALL_SPOT_MARKET_BIDS',
}
